import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  resetPasswordWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native form controls / scrollbars follow the active theme.
    colorScheme: theme.palette.type,
    height: '100vh',
    '& h4': {
      // `secondary.silver` is only declared in the DARK palette, so in light this
      // declaration was dropped and the heading simply inherited. Left out
      // entirely now: keeping it would have made these headings render in a dark
      // SURFACE colour once this page became themeable, i.e. invisible.
      fontWeight: '200',
      marginTop: '60px',
    },
    '& a': {
      // Was 'white', i.e. invisible on the white page — the "go back to login"
      // link could only be found by hovering. Matches Login's `& a` rule now.
      color: theme.palette.primary.main,
      fontSize: '13px',
    },
    '& img': {
      display: 'block',
      margin: 'auto',
    },
    '& .MuiTextField-root': {
      marginBottom: '10px',
    },
  },
  resetPassword: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '400px',
  },
  title: {
    paddingBottom: '30px',
    paddingTop: '50px',
    fontSize: '20px',
  },
  // Dead: no component applies this class (errors surface through <Snackbar>).
  // Pointed at the error token anyway so re-wiring it does not resurrect the
  // original white-on-white.
  error: {
    color: theme.palette.custom.errorText,
    minHeight: '10px',
    fontSize: '10px',
  },
  passwordLink: {
    display: 'grid',
    justifyContent: 'center',
    marginTop: '15px',
  },
  image: {
    maxWidth: '280px',
    maxHeight: '100%',
  },
}));

export default useStyles;
